module.exports = __webpack_public_path__ + "img/钟表-6.0775b9ce.png";